<template>
    <div class="row">
        <div class="col">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title">Change Div Color</h5>
                    <p class="card-text">Click the button to change the color of the div below.</p>
                    <button class="btn btn-primary" @click="changeDivColor">Change Color</button>
                </div>
            </div>
            <div class="mt-3" :style="{ backgroundColor: count % 2 === 0 ? 'lightblue' : 'lightcoral', height: '100px' }">
                <!-- This div changes color based on the count value -->
            </div>
        </div>
    </div>
</template>

<script setup>
    //composition API using setup script
    const { ref, onMounted } = Vue;
    const count = ref(1);

    function changeDivColor() {
        count.value = count.value === 1 ? 2 : 1;
    }

    onMounted(() => {
        console.log("OnMounted called from the ColorChanger component....eat a dick.");
    })


</script>

<style scoped>
</style>